import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Modal, Card, CardContent, Stack, Button, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ConfirmCloseOrder = ({ open, handleClose, handleCloseOrder }) => {
  const { order } = useSelector(state => state.app);

  return (<Modal
    open={open}
    onClose={handleClose}
  >
    <Card sx={{ ...style }}>
      <CardContent sx={{ flexGrow: 1, width: '400px' }}>
        <Typography variant="body1" textAlign="center">
              Czy na pewno chcesz zamknąć zamówienie o numerze <span style={{ fontWeight: 'bold' }}>{order.identifier}</span>? Niezapisane zmiany zostaną utracone.
        </Typography>
        <Box height={40} />
        <Stack flexDirection="row" justifyContent="space-around">
          <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Nie</Button>
          <Button sx={{ flexGrow: 0.4 }} variant="contained" onClick={handleCloseOrder}>Tak</Button>
        </Stack>
      </CardContent>
    </Card>
  </Modal>);
};

export default ConfirmCloseOrder;
